import { render, staticRenderFns } from "./CouponIndicator.vue?vue&type=template&id=4c14e201&scoped=true&"
import script from "./CouponIndicator.vue?vue&type=script&lang=js&"
export * from "./CouponIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CouponIndicator.vue?vue&type=style&index=0&id=4c14e201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c14e201",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c14e201', component.options)
    } else {
      api.reload('4c14e201', component.options)
    }
    module.hot.accept("./CouponIndicator.vue?vue&type=template&id=4c14e201&scoped=true&", function () {
      api.rerender('4c14e201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/common_components/CouponIndicator.vue"
export default component.exports